import { useContext } from 'react'
import { SavedReportsContext } from '../Contexts/SavedReportsProvider'

export const useSavedReportsContext = () => useContext(SavedReportsContext)
